//  Package imports.
import PropTypes from "prop-types";
import { PureComponent } from "react";

import { defineMessages, injectIntl } from "react-intl";

import ImmutablePropTypes from "react-immutable-proptypes";


//  Mastodon imports.
import { Icon } from "flavours/glitch/components/icon";
import { languages } from "flavours/glitch/initial_state";

import { IconButton } from "./icon_button";
import LocalOnlyIcon from "./status_local_only_icon";
import VisibilityIcon from "./status_visibility_icon";

//  Messages for use with internationalization stuff.
const messages = defineMessages({
  collapse: { id: "status.collapse", defaultMessage: "Collapse" },
  uncollapse: { id: "status.uncollapse", defaultMessage: "Uncollapse" },
  inReplyTo: { id: "status.in_reply_to", defaultMessage: "This post is a reply" },
  previewCard: { id: "status.has_preview_card", defaultMessage: "Features an attached preview card" },
  pictures: { id: "status.has_pictures", defaultMessage: "Features attached pictures" },
  poll: { id: "status.is_poll", defaultMessage: "This post is a poll" },
  video: { id: "status.has_video", defaultMessage: "Features attached videos" },
  audio: { id: "status.has_audio", defaultMessage: "Features attached audio files" },
});

const LanguageIcon = ({ language }) => {
  if (!languages) {
    return null;
  }

  const lang = languages.find((lang) => lang[0] === language);
  if (!lang) {
    return null;
  }

  return (
    <span className='text-icon' title={`${lang[2]} (${lang[1]})`} aria-hidden='true'>
      {lang[0].toUpperCase()}
    </span>
  );
};

LanguageIcon.propTypes = {
  language: PropTypes.string.isRequired,
};

class StatusIcons extends PureComponent {

  static propTypes = {
    status: ImmutablePropTypes.map.isRequired,
    mediaIcons: PropTypes.arrayOf(PropTypes.string),
    collapsible: PropTypes.bool,
    collapsed: PropTypes.bool,
    setCollapsed: PropTypes.func.isRequired,
    intl: PropTypes.object.isRequired,
    settings: ImmutablePropTypes.map.isRequired,
  };

  //  Handles clicks on collapsed button
  handleCollapsedClick = (e) => {
    const { collapsed, setCollapsed } = this.props;
    if (e.button === 0) {
      setCollapsed(!collapsed);
      e.preventDefault();
    }
  };

  mediaIconTitleText (mediaIcon) {
    const { intl } = this.props;

    const message = {
      "link": messages.previewCard,
      "picture-o": messages.pictures,
      "tasks": messages.poll,
      "video-camera": messages.video,
      "music": messages.audio,
    }[mediaIcon];

    return message && intl.formatMessage(message);
  }

  renderIcon (mediaIcon) {
    return (
      <Icon
        className='status__media-icon'
        key={`media-icon--${mediaIcon}`}
        id={mediaIcon}
        aria-hidden='true'
        title={this.mediaIconTitleText(mediaIcon)}
      />
    );
  }

  //  Rendering.
  render () {
    const {
      status,
      mediaIcons,
      collapsible,
      collapsed,
      settings,
      intl,
    } = this.props;

    return (
      <div className='status__info__icons'>
        {settings.get("language") && status.get("language") && <LanguageIcon language={status.get("language")} />}
        {settings.get("reply") && status.get("in_reply_to_id", null) !== null ? (
          <Icon
            className='status__reply-icon'
            id='arrow-bend-double-up-left'
            aria-hidden='true'
            title={intl.formatMessage(messages.inReplyTo)}
          />
        ) : null}
        {settings.get("local_only") && status.get("local_only") && <LocalOnlyIcon />}
        {settings.get("media") && !!mediaIcons && mediaIcons.map(icon => this.renderIcon(icon))}
        {settings.get("visibility") && <VisibilityIcon visibility={status.get("visibility")} />}
        {collapsible && (
          <IconButton
            className='status__collapse-button'
            animate
            active={collapsed}
            title={
              collapsed ?
                intl.formatMessage(messages.uncollapse) :
                intl.formatMessage(messages.collapse)
            }
            icon='caret-circle-double-up'
            onClick={this.handleCollapsedClick}
          />
        )}
      </div>
    );
  }

}

export default injectIntl(StatusIcons);
